import { SingService } from "app/components/service/sing.service";
import { Injectable } from "@angular/core";
import { Client } from "app/components/app/class/client";
@Injectable()
export class HomeService {
    constructor(private httpService: SingService) {
        
    }
    public getClients () {
    return this.httpService.getClients();
    }
    public getAuthData() {
        return this.httpService.getAuthData();
    }
    public setClient(list:Array<Client>) {
        let clients: Array<Client> = list;
        if (window.localStorage.getItem("clientId")) {
            let clientLast: number = Number(window.localStorage.getItem("clientId"));
            let indexClient: number = clients.findIndex(element => element.id === clientLast);
            if (indexClient !== (-1)) {
                window.localStorage.setItem("clientId", String(clientLast));
                window.location.href = `/rtb?id=${clientLast}`;
            }
            else {
                window.localStorage.setItem("clientId", String(clients[0].id));
                window.location.href = `/rtb?id=${clients[0].id}`;
            }

        }
        else {
            window.localStorage.setItem("clientId", String(clients[0].id));
            window.location.href = `/rtb?id=${clients[0].id}`;
        }
    }
}


// WEBPACK FOOTER //
// ./src/app/components/home/services/home.service.ts